<div class="row">

  <div class="address">

    <div class="firma">
      ExploSYS GmbH
    </div>

    <div class="institute">
      Interdisciplinary Institute<br>
      for Exploratory Systems
    </div>

    <p>
      Fronländer 7<br>
      72072 Tübingen<br>
      Germany
    </p>

    <p>
      Phone: +49 7472 | 9247809
      Mobile: +49 1575 3591734
    </p>

  </div>

  <div class="helix">
    <div class="align-left">Mathematics</div>
    <div class="align-right">Systems Biology</div>
    <div class="align-left">Statistics</div>
    <div class="align-right">Epidemiology</div>
    <div class="align-left">Data Science</div>
    <div class="align-right">Public Health</div>
    <div class="align-left">Visualisation</div>
    <div class="align-right">Ecology</div>
    <div class="align-left spacing">ExploSYS</div>
  </div>

</div>
